/* Polyfill cho hàm Shopify.formatMoney bị thiếu */
window.Shopify = window.Shopify || {};
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var val = (cents / 100).toFixed(2);
    return '$' + val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
}


/* product.js: variant picker, product gallery, PhotoSwipe */

/* ===== Alpine.js product variant component ===== */
document.addEventListener('alpine:init', function() {
  Alpine.data('productVariant', function() {
    return {
      variants: [],
      selectedOptions: [],
      optionNames: [],
      currentVariantId: null,
      currentVariantAvailable: true,
      qty: 1,
      loading: false,
      _initialized: false,
      _modelSyncing: false,

      init: function() {
        const jsonEl = this.$root.querySelector('[data-product-json]');
        if (jsonEl) {
          try {
            this.variants = JSON.parse(jsonEl.textContent);
          } catch (e) {
            console.error('Failed to parse product variants JSON:', e);
            this.variants = [];
          }
        }

        const optionsEl = this.$root.querySelector('#product-options-json');
        if (optionsEl) {
           try {
             this.optionNames = JSON.parse(optionsEl.textContent);
           } catch(e) {}
        }

        // Parse URL params to override defaults
        const urlParams = new URLSearchParams(window.location.search);
        let hasUrlOptions = false;

        if (this.optionNames.length > 0) {
          this.optionNames.forEach((name, i) => {
            const val = urlParams.get(name);
            if (val) {
              hasUrlOptions = true;
            }
          });
        }

        // Read initial selected options from checked radios
        const self = this;

        if (hasUrlOptions) {
          // Uncheck defaults
          const allInputs = this.$root.querySelectorAll('[data-variant-input]');
          allInputs.forEach(input => input.checked = false);

          this.optionNames.forEach((name, i) => {
             const targetValue = urlParams.get(name);
             if (targetValue) {
                // escape quotes for querySelector
                const safeVal = targetValue.replace(/"/g, '\\"');
                const input = this.$root.querySelector(`[data-variant-input][name="option-${i}"][value="${safeVal}"]`);
                if (input) {
                   input.checked = true;
                   self.selectedOptions[i] = targetValue;
                }
             }
          });

          // Fill missing ones from DOM default if not specified in URL
          const checkedInputs = this.$root.querySelectorAll('[data-variant-input]:checked');
          checkedInputs.forEach(function(input) {
            const idxMatch = input.name.match(/option-(\d+)/);
            if(idxMatch) {
               self.selectedOptions[idxMatch[1]] = input.value;
            }
          });
        } else {
          const checkedInputs = this.$root.querySelectorAll('[data-variant-input]:checked');
          checkedInputs.forEach(function(input, i) {
            self.selectedOptions[i] = input.value;
          });
        }

        this.matchVariant();
        this._initialized = true;

        // Trigger change on init so Shopify payment button picks up the variant
        const initSelf = this;
        setTimeout(function() {
          const variantInput = initSelf.$root.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 100);

        // ── Bidirectional sync: Model → Size ──
        // Khi user chọn model từ Switch Model modal, tự động chuyển Size tương ứng
        window.addEventListener('scrubloop:model-selected', function(e) {
          var model = e.detail.model;
          self._modelSyncing = true;
          for (var i = 0; i < self.optionNames.length; i++) {
            if (self.optionNames[i].toLowerCase() === 'size') {
              var sizeValue = model.top_size;
              var safeVal = sizeValue.replace(/"/g, '\\"');
              var input = self.$root.querySelector(
                'input[name="option-' + i + '"][value="' + safeVal + '"]'
              );
              if (input && !input.checked) {
                input.checked = true;
                self.updateOption(i, sizeValue);
              }
              break;
            }
          }
          self._modelSyncing = false;
        });
      },

      updateOption: function(index, value) {
        this.selectedOptions[index] = value;
        this.matchVariant();

        // ── Bidirectional sync: Size → Model ──
        // Khi user chọn Size, tự động switch gallery sang model tương ứng
        if (this._initialized && !this._modelSyncing
            && this.optionNames[index]
            && this.optionNames[index].toLowerCase() === 'size') {
          window.dispatchEvent(new CustomEvent('scrubloop:size-selected', {
            detail: { size: value, token: value.toLowerCase().trim() }
          }));
        }
      },

      matchVariant: function() {
        const self = this;
        const matched = this.variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === self.selectedOptions[i];
          });
        });

        if (matched) {
          this.currentVariantId = matched.id;
          this.currentVariantAvailable = matched.available;

          // Update URL without reload (only after user interaction, not on init)
          if (this._initialized) {
            const url = new URL(window.location.href);
            url.searchParams.delete('variant');

            if (this.optionNames && this.optionNames.length > 0) {
              this.optionNames.forEach((name, i) => {
                 if (this.selectedOptions[i]) {
                    url.searchParams.set(name, this.selectedOptions[i]);
                 }
              });
            } else {
              url.searchParams.set('variant', matched.id);
            }

            window.history.replaceState({}, '', url.toString());
          }

          // Notify Shopify payment button of variant change
          const variantInput = this.$root.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = matched.id;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Update price display
          this.updatePrice(matched);

          // Sync gallery to variant image
          this.syncGallery(matched);
        } else {
          // No variant for this option combination — clear the selection so the
          // form cannot submit the previously matched variant.
          this.currentVariantId = null;
          this.currentVariantAvailable = false;

          const variantInput = this.$root.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = '';
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      },

      updatePrice: function(variant) {
        const priceEl = document.querySelector('[data-product-price]');
        if (!priceEl) return;

        let html = '<div class="flex items-center gap-2 flex-wrap text-xl">';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="text-gray-400 text-sm">' + Shopify.formatMoney(variant.compare_at_price) + '</s>';
          html += '<span class="text-accent font-semibold">' + Shopify.formatMoney(variant.price) + '</span>';
          const savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          html += '<span class="text-accent text-sm font-semibold">Save ' + savings + '%</span>';
        } else {
          html += '<span>' + Shopify.formatMoney(variant.price) + '</span>';
        }
        html += '</div>';
        priceEl.innerHTML = html;
      },

      syncGallery: function(variant) {
        if (!variant.featured_image || !window.ScrubloopGallery) return;
        const gallery = document.getElementById('product-gallery');
        if (!gallery) return;

        const slides = gallery.querySelectorAll('[data-gallery-list] > li');
        const filename = variant.featured_image.src.split('?')[0].split('/').pop();
        for (let i = 0; i < slides.length; i++) {
          const img = slides[i].querySelector('img');
          // A slide not loaded yet keeps its URL in data-defer-src (theme.js deferred images)
          const src = img ? (img.getAttribute('src') || img.getAttribute('data-defer-src') || '') : '';
          if (src.includes(filename)) {
            window.ScrubloopGallery.go(i);
            break;
          }
        }
      }
    };
  });
});

/* ===== Product gallery (emblaSlider from theme.js) =====
   snippets/product-gallery.liquid is an emblaSlider (loop) whose thumb lists
   read and set the same `index`. This file only adds the fit-model filter:
   window.ScrubloopGallery, used by snippets/product-fit-model-switcher.liquid
   and syncGallery. It runs on DOMContentLoaded, after Alpine has initialised
   the Switch Model component (it reads every slide before filtering).
   Rebuilding the main list makes Embla re-init by itself (watchSlides), and
   Alpine initialises the cloned thumbs, which take their position from data-i. */
document.addEventListener('DOMContentLoaded', function() {
  const mainEl = document.getElementById('product-gallery');
  if (!mainEl) return;
  const rootEl = mainEl.closest('[x-data]');
  const thumbsEl = document.getElementById('product-thumbs');
  const thumbsMobileEl = document.getElementById('product-thumbs-mobile');

  function slider() {
    return window.Alpine && rootEl ? Alpine.$data(rootEl) : null;
  }

  // Snapshot the ORIGINAL slides, one master set per list. Every model switch
  // rebuilds the visible list from these masters.
  function snapshot(list) {
    if (!list) return null;
    const slides = [];
    for (let i = 0; i < list.children.length; i++) {
      slides.push(list.children[i].cloneNode(true));
    }
    return { list: list, slides: slides };
  }
  const snap = {
    main: snapshot(mainEl.querySelector('[data-gallery-list]')),
    thumbs: snapshot(thumbsEl && thumbsEl.querySelector('ul')),
    thumbsMobile: snapshot(thumbsMobileEl && thumbsMobileEl.querySelector('ul'))
  };

  // Keep a slide if it is common (data-model empty) or matches the token.
  // A fragment so each list changes in one mutation (one Embla re-init).
  function fillList(master, token) {
    if (!master) return 0;
    const frag = document.createDocumentFragment();
    let count = 0;
    master.slides.forEach(function(node) {
      const m = node.getAttribute('data-model') || '';
      if (!token || m === '' || m === token) {
        const copy = node.cloneNode(true);
        if (copy.hasAttribute('data-i')) copy.setAttribute('data-i', count);
        frag.appendChild(copy);
        count++;
      }
    });
    master.list.innerHTML = '';
    master.list.appendChild(frag);
    return count;
  }

  // Activate deferred images that were cloned from the snapshot
  // (snapshot was taken before theme.js swapped data-defer-src → src)
  function activateDeferredImages() {
    [mainEl, thumbsEl, thumbsMobileEl].forEach(function(el) {
      if (!el) return;
      var imgs = el.querySelectorAll('[data-defer-src]');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var src = img.getAttribute('data-defer-src');
        var srcset = img.getAttribute('data-defer-srcset');
        if (src) { img.setAttribute('src', src); img.removeAttribute('data-defer-src'); }
        if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-defer-srcset'); }
      }
    });
  }

  function showModel(token, first) {
    fillList(snap.main, token);
    fillList(snap.thumbs, token);
    fillList(snap.thumbsMobile, token);
    activateDeferredImages();
    // Embla keeps its index through the re-init; a switch starts on the model's
    // first image, as before. Wait for the re-init (MutationObserver) first.
    if (!first) setTimeout(function() { window.ScrubloopGallery.go(0); }, 0);
  }

  // Public API consumed by snippets/product-fit-model-switcher.liquid and syncGallery
  window.ScrubloopGallery = {
    setModel: function(token) { showModel(token || null, false); },
    go: function(i) { window.dispatchEvent(new CustomEvent('product-gallery-go', { detail: { index: i } })); },
    next: function() { const s = slider(); if (s) s.next(); },
    prev: function() { const s = slider(); if (s) s.prev(); },
    goPage: function(p) { this.go(p); },
    // First image belonging to a model, used for the picker card thumbnails.
    // Prefers the light 150px thumb strip; falls back to the main gallery.
    thumbFor: function(token) {
      const master = snap.thumbs || snap.main;
      if (!master) return '';
      for (let i = 0; i < master.slides.length; i++) {
        if ((master.slides[i].getAttribute('data-model') || '') === token) {
          const img = master.slides[i].querySelector('img');
          if (img) return img.getAttribute('src') || img.getAttribute('data-defer-src') || '';
        }
      }
      return '';
    }
  };

  // Initial view = default model (first roster entry), else all slides.
  const defaultToken = mainEl.getAttribute('data-default-model') || null;
  showModel(defaultToken, true);
});

/* ===== Product Recommendations ===== */
document.addEventListener('DOMContentLoaded', function() {
  const placeholder = document.querySelector('[data-recommendations-placeholder]');
  if (!placeholder) return;

  const url = placeholder.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function(res) {
      if (!res.ok) throw new Error('Recommendations fetch failed');
      return res.text();
    })
    .then(function(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('.shopify-section');
      if (!section || !section.innerHTML.trim()) return;

      placeholder.innerHTML = section.innerHTML;

      // The injected carousel is an Alpine component; Alpine mounts it on insertion.
    })
    .catch(function(e) {
      console.warn('Product recommendations failed:', e);
    });
});
